import { Component, html, LitElement, property, query } from '@rxdi/lit-html';
import { InputStyle } from '@rxdi/ui-kit/styles/form/input';
import { Observable } from 'rxjs';

/**
 * @customElement input-toggle
 */
@Component({
  selector: 'input-toggle',
  style: InputStyle,
  template(this: InputToggleComponent) {
    return html`
      <label class="rx-switch">
        <input
          @change=${(e) => {
            e.preventDefault();
            this.OnChange();
          }}
          type="checkbox"
        />
        <span class="rx-slider"></span>
      </label>
    `;
  },
})
export class InputToggleComponent extends LitElement {
  private enter: Observable<Event>;

  @query('input')
  private input: HTMLInputElement;

  @property({ type: Boolean })
  checked: boolean;

  OnUpdate() {
    if (this.input) {
      this.input.checked = this.checked;
    }
  }

  OnChange() {
    this.dispatchEvent(
      new CustomEvent<HTMLInputElement>('toggled', {
        detail: this.input,
      })
    );
  }
}
